import Immutable from 'immutable';

import type { FontAsset } from 'js/src/client';
import { archiveFontWithId, beginLoadingFonts, storeFonts } from 'js/src/data/fonts/fonts-actions';
import { areFontsLoaded, isFontListLoading } from 'js/src/data/fonts/fonts-selectors';
import type { ImmutableMap } from 'js/src/libs/consts';
import FontLoader from 'js/src/libs/font-loader';
import type { AppDispatch } from 'js/src/libs/RootState';
import type { GetRootState } from 'js/src/luminary/luminary-redux-connect-types';

export function loadFonts() {
    return (dispatch: AppDispatch, getState: GetRootState) => {
        if (isFontListLoading(getState())) {
            return;
        }

        dispatch(beginLoadingFonts());
        new FontLoader((fontList) => {
            dispatch(storeFonts({ fontList }));
        });
    };
}

/**
 * Ensures fonts are loaded before proceeding. Returns a Promise that resolves
 * once fonts are available in Redux. If fonts are already loaded, resolves immediately.
 */
export function ensureFontsLoaded() {
    return (dispatch: AppDispatch, getState: GetRootState): Promise<void> => {
        if (areFontsLoaded(getState())) {
            return Promise.resolve();
        }

        return new Promise<void>((resolve) => {
            dispatch(beginLoadingFonts());
            new FontLoader((fontList) => {
                dispatch(storeFonts({ fontList }));
                resolve();
            });
        });
    };
}

export function archiveFont(fontAsset: ImmutableMap<FontAsset>) {
    return (dispatch: AppDispatch) => {
        FontLoader.deleteFont(fontAsset);
        dispatch(archiveFontWithId({ fontId: fontAsset.get('id') }));
    };
}

export function addFont(fontAsset: ImmutableMap<FontAsset>) {
    return (dispatch: AppDispatch) => {
        FontLoader.addFont(fontAsset);
        dispatch(
            storeFonts({
                fontList: Immutable.List([fontAsset]),
            }),
        );
    };
}
